"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTextWidth = void 0;
var _styles = require("@mui/styles");
var useTextWidth = exports.useTextWidth = function useTextWidth(font) {
  var canvas = document.createElement('canvas');
  var context = canvas.getContext('2d');
  var theme = (0, _styles.useTheme)();
  canvas.style.letterSpacing = theme.typography.body2.letterSpacing;
  return function (text) {
    context.font = font || "".concat(theme.typography.body2.fontSize, " ").concat(theme.typography.body2.fontFamily);
    return context.measureText(text).width;
  };
};